import { memo, useCallback, useState } from 'react';
import { Col, FormInput, Row } from 'shards-react';

const StatefulField = ({ id = '', type = 'text', value = '', updateValue = () => null, isRequired = false, autoComplete = 'off', label = '', placeholder = label, hint = '', validator = false, maxLength = '' }) => {
  const [isChanged, setIsChanged] = useState(() => false);
  const isValid = isChanged && validator;
  const isInvalid = isChanged && !isValid;

  const handleChange = useCallback(
    ({ target: { value } }) => {
      if (!isChanged) setIsChanged(true);
      return updateValue(value);
    },
    [isChanged, setIsChanged, updateValue]
  );

  return (
    <Row className='mb-3'>
      <Col md='6'>
        <label htmlFor={id}>{label}</label>
        <FormInput id={id} type={type} required={isRequired} placeholder={placeholder} maxLength={maxLength} value={value} autoComplete={autoComplete} valid={isValid} invalid={isInvalid} onChange={handleChange} />
      </Col>
      {isChanged && hint && (
        <Col md='6' className='align-self-end text-danger'>
          {hint}
        </Col>
      )}
    </Row>
  );
};

export default memo(StatefulField);
